export function GetDaysFromDates(userDate, currentDate = new Date()) {
    userDate = new Date(userDate.replace(" ", "T") + "Z");
    let difference = userDate.getTime() - currentDate.getTime();
    let value = Math.ceil(difference / (1000 * 3600 * 24));
    return value == "-0" ? "today" : value + " days ago";
  }